import React, {useState} from 'react';
import {ErrorMessage, Field} from "formik";
import NumberKeyboard from "../../components/NumberKeyboard";
import {Add, Savings, Store} from "@mui/icons-material";
import {formatCurrency} from "../../utils";

function StageAmount({ submitform, values, setFieldValue }) {
  let [focus, setFocus] = useState('amount');

  const onNumberPress = (values, setFieldValue) => (value) => {
    const currency = values.currency === 'USDLBP' ? (focus === 'amount' ? 'USD' : 'LBP') : values.currency;
    const amount = (values[focus] ?? 0).toString();

    // console.log(`press ${value}`, values);
    let newValue = currency === 'LBP' && amount.length > 3 ? amount.slice(0, -3) : amount;
    if (value === 'del') {
      newValue = newValue.slice(0, -1);
    } else if (value === '-') {
      newValue = amount.startsWith('-') ? amount.substring(1) : `-${amount}`;
    } else if (amount === '0') {
      newValue = value;
    } else {
      newValue = `${newValue}${value}`;
    }
    if (currency === 'LBP' && value !== '-') {
      newValue += '000';
    }
    setFieldValue(focus, newValue || '0');
  };

  const onReturnKey = () => {
    if (values.currency === 'USDLBP') {
      if (focus === 'amount') {
        setFocus('amount2');
      } else if (parseFloat(values.amount) === 0) {
        setFocus('amount');
      } else if (parseFloat(values.amount2) === 0) {
        setFocus('amount2');
      } else {
        submitform()
      }
    } else {
      submitform();
    }
  }

  const amountFormat = (amount, currency) => {
    if (!amount) {
      return 0;
    }
    return formatCurrency(amount, currency === 'USDLBP' ? 'USD' : currency);
  };
  const typeClass = (amount) => amount && amount.startsWith('-') ? 'income' : 'expense';

  return <div className="stage-amount">
    <div className={`amount-group ${values.currency}`}>
      <div className={`amount ${focus==='amount' ? 'focused' : ''} ${typeClass(values.amount)}`}
           onClick={() => setFocus('amount')}>
        <Field type="hidden" name="amount" />
        <span className="type">
          <span className="expense"><Store /><span>Expense</span></span>
          <span className="income"><Savings /><span>Income</span></span>
        </span>
        <span className="formatted">
          {amountFormat(values.amount, values.currency)}
        </span>
        <span className="error"><ErrorMessage name="amount" /></span>
      </div>

      <div className="plus-icon">
        <Add fontSize={'large'} />
      </div>

      <div className={`amount2 ${focus==='amount2' ? 'focused' : ''} ${typeClass(values.amount2)}`} onClick={() => setFocus('amount2')}>
        <Field type="hidden" name="amount2" />
        <span className="type">
          <span className="expense"><Store /><span>Expense</span></span>
          <span className="income"><Savings /><span>Income</span></span>
        </span>
        <span className="formatted">
          {amountFormat(values.amount2, 'LBP')}
        </span>
        <span className="error"><ErrorMessage name="amount" /></span>
      </div>
    </div>

    <div role="group" aria-labelledby="currency-radio-group" className="currency-radio-group">
      <label>
        <Field type="radio" name="currency" value="USD" />
        <span>USD</span>
      </label>
      <label>
        <Field type="radio" name="currency" value="USDLBP" />
        <span>USD+LBP</span>
      </label>
      <label>
        <Field type="radio" name="currency" value="LBP" />
        <span>LBP</span>
      </label>
    </div>
    <NumberKeyboard negate onFormSubmit={onReturnKey} onKeyPress={onNumberPress(values, setFieldValue)} />
  </div>;
}

export default StageAmount;